import { useTranslation } from "react-i18next";
import BasePage from "../BasePage/BasePage";
import "./TermsOfUse.scss";

function TermsOfUse() {
  const { i18n, t } = useTranslation("register");

  return (
    <BasePage size={5}>
      <div className="p-md-5 mx-md-4">
        <h1>{t("termsOfUse.title")}</h1>
        <p className="my-5 pb-1 login-headline">{t("termsOfUse.text")}</p>
      </div>
    </BasePage>
  );
}

export default TermsOfUse;
